import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Form, FormControl, InputGroup, Row } from 'react-bootstrap';
import debounce from 'lodash.debounce';
import generalRouteService from '../services/general_route.service';
import SearchResults from './SearchResults';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import HowToSearch from './tutorial/HowToSearch';
import HowToSearchModal from './modal/HowToSearchModal';
import { useErrorHandling } from '../hooks/useErrorHandling';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
const FolderAndFileSearch = _ref => {
  let {
    inputRef,
    fileUploaderUsers,
    goToFolderQuery,
    query,
    setQuery
  } = _ref;
  const [folderSearchResults, setFolderSearchResults] = useState([]);
  const [fileSearchResults, setFileSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [userId, setUserId] = useState('');
  const [showHowToSearchModal, setHowToSearchModal] = useState(false);
  const {
    search
  } = useLocation();
  const modelName = new URLSearchParams(search).get('model_name');
  const {
    t
  } = useTranslation();
  const callSearchEndpoints = useErrorHandling(useCallback(async (searchQuery, userId) => {
    const modelId = new URLSearchParams(location.search).get('model_id');
    const modelType = new URLSearchParams(location.search).get('model_type');
    const folderResults = await generalRouteService.getAll('folders', `?type=${modelType}&id=${modelId}&search=${searchQuery}`);
    const fileResults = await generalRouteService.getAll('folder_files', `?type=${modelType}&search=${searchQuery}&id=${modelId}&user_id=${userId}`);
    setLoading(false);
    setFolderSearchResults([...folderResults]);
    setFileSearchResults([...fileResults]);
  }, []));
  const getSearchResults = useMemo(() => {
    return debounce(callSearchEndpoints, 1000);
  }, []);
  const searchIfValueExists = value => {
    if (!value.length) return;
    setLoading(true);
    getSearchResults(value, userId);
  };
  const searchQuery = e => {
    setQuery(e.target.value);
    searchIfValueExists(e.target.value);
  };
  const searchOnFocus = e => {
    const valueChanged = query !== e.target.value;
    const thereIsValue = !!e.target.value.length;
    const noFolderInSearchResults = !folderSearchResults.length;
    const noFileInSearchResults = !fileSearchResults.length;
    const thereIsValueButNoResults = noFolderInSearchResults && noFileInSearchResults && thereIsValue;
    if (valueChanged || thereIsValueButNoResults) {
      searchIfValueExists(e.target.value);
    }
  };
  const searchWithNewUser = e => {
    const newUserId = e.target.value;
    setUserId(newUserId);
    getSearchResults(query, newUserId);
  };
  useEffect(() => {
    if (!query.length) {
      setFolderSearchResults([]);
      setFileSearchResults([]);
    }
  }, [query]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HowToSearchModal, {
    show: showHowToSearchModal,
    onHide: () => setHowToSearchModal(false)
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(FormControl, {
    ref: inputRef,
    placeholder: t('search_something'),
    value: query,
    onFocus: searchOnFocus,
    onChange: searchQuery
  })), /*#__PURE__*/React.createElement("small", {
    className: "ms-2",
    style: {
      opacity: '0.6'
    }
  }, t('click_here_or_press_ctrol+f_to_search')))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('uploaded_by')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Control, {
    disabled: !query.length,
    as: "select",
    name: "user_id",
    onChange: searchWithNewUser,
    size: "md"
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }, t('select_type')), fileUploaderUsers.map(u => {
    return /*#__PURE__*/React.createElement("option", {
      key: u[0] + 'userId',
      value: u[0]
    }, u[1]);
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    loading: loading,
    disabled: !query.length,
    variant: "light",
    onClick: () => setQuery('')
  }, t('clear_search_query')), !!query.length && /*#__PURE__*/React.createElement("small", {
    className: "ms-2",
    style: {
      opacity: '0.6'
    }
  }, t('click__or_press_escape_to_clear_search'))), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(HowToSearch, {
    showInstruction: () => setHowToSearchModal(true)
  }))), !!query.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchResults, {
    queryIsEmpty: !query.length,
    folderSearchResults: folderSearchResults,
    fileSearchResults: fileSearchResults,
    loading: loading,
    goToFolderQuery: goToFolderQuery,
    modelName: modelName
  })));
};
export default FolderAndFileSearch;